import React from 'react';
import { motion } from 'framer-motion';

const CasosPlaPi = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      exit={{ opacity: 0, y: -20 }}
      className="max-w-4xl mx-auto px-4 py-12"
    >
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-transparent mb-6">
          Casos sobre plagio y propiedad intelectual
        </h1>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-4 md:p-8">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 text-center">
          The Hunt [La caza] (Apple TV): debate sobre plagio y propiedad intelectual, ¿copiar o inspirar?
        </h2>
        
        <div className="flex justify-center mb-8">
          <div className="w-full max-w-sm">
            <div className="relative pb-[177.78%] h-0 overflow-hidden rounded-lg shadow-lg">
              <div style={{ padding: '177.78% 0 0 0', position: 'relative' }}>
                <div style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}>
                  <iframe 
                    height="100%" 
                    width="100%" 
                    src="https://embed.wave.video/P6ljGdNA5FH96w6s" 
                    frameBorder="0" 
                    allow="autoplay; fullscreen" 
                    scrolling="no"
                    title="The Hunt Case Study"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            Fuente:{' '}
            <a 
              href="https://www.tiktok.com/@alfredmenendez/video/7609761797649763602" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-indigo-600 dark:text-indigo-400 hover:underline"
            >
              Menéndez (2026).
            </a>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default CasosPlaPi;